import StudentThumbnail from './StudentThumbnail';

export default StudentThumbnail;
